<template>
    <div class="">
        <div class="wrapper wrapper-full-page section content">
            <!-- bg-main -->
            <div class="container">
                <!-- controll -->
                    <!-- {{ getTokenUrl }} -->
                    <Keypress :multiple-keys="multiple" key-event="keyup"  @success="checkTimeWork" @wrong="otherMethod" />
                    <b-input hidden v-model="valKey"></b-input>
                <!-- controll -->
                <div class="row">
                    <div class="col-md-12"> 
                        <b-card class="mt-5 bg-card height-card card-custom mb-1" text-variant="white">
                            <b-card-text class="mb-2">
                                <h1 class="clock-warning font-01 font-weight-bold mt-0 mb-1">{{ currentTime }}</h1>
                                <small class="font-en-chk"><i class="fa fa-calendar mr-1" aria-hidden="true"></i>Today : {{ moment().format('LL') }}</small>
                                <br>
                                <small class="mb-0"><i class="fa fa-map-marker mr-1" aria-hidden="true"></i>Location : </small>
                            </b-card-text>
                            <hr class="bg-white mb-2 mt-0">
                            <b-alert class="mt-0" show variant="dark-custom">
                                <!-- danger-custom -->
                                <b-media>
                                    <template v-slot:aside>
                                        <i class="mt-3 fa fa-id-badge fa-4x mt-1 ml-2 mr-4 text-white" aria-hidden="true"></i> 
                                        <!-- check-success -->
                                        <!-- <i class="fa fa-times fa-4x mt-1 ml-2 mr-4 check-warning" aria-hidden="true"></i> -->
                                    </template>
                                    <div class="text-white">
                                        <div class="mt-2 d-flex justify-content-between w-100">
                                            <h5 class="mt-0 mb-0 font-weight-bold">ID : </h5>
                                            <h5 class="mt-0 mb-0 font-weight-bold text-success">13000649</h5>
                                        </div>
                                        <div class="mt-2 d-flex justify-content-between w-100">
                                            <p class="mb-0 font-weight-bold">Name : </p>
                                            <p class="mb-0 font-weight-bold text-success">KITSANA cHUNCHOM</p>
                                        </div>
                                        <div class="mt-2 d-flex justify-content-between w-100">
                                            <p class="mt-0 mb-0 font-weight-bold">Time stamp : </p>
                                            <p class="mt-0 mb-0 font-weight-bold text-success">{{ moment().format('LTS') }}</p>
                                        </div>
                                    </div>
                                    <!-- <h5 class="mt-0 mb-0 danger-custom font-weight-bold">There is a problem with your card. Please contact the staff to check.</h5> -->
                                </b-media>
                            </b-alert>
                        </b-card>
                        <!-- <small class="h6 mt-1 text-capitalize"><i class="fa fa-history mr-1" aria-hidden="true"></i>History</small>  -->
                        <small class="float-center h6 mt-1 ml-3 text-capitalize">Mahidol University International College</small>
                        <!-- msg error -->
                        <h6 v-if="msgError !== ''" class="mt-3 ml-2 mb-0 font-weight-bold text-danger text-">Error : {{ msgError }}</h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {
            Keypress: () => import('vue-keypress'),
        },
        data(){
            return{
                currentTime:null,
                countData: 0,
                hou: 0,
                sec: 5,
                // key
                valKey: '',
                valTemp: 'Key name',
                multiple: [
                    {
                        keyCode: 13, // Enter
                        modifiers: [],
                        preventDefault: true,
                    },
                ],
                // item response
                msgError: "",
                loadingScan: false,
                itemCheck: [],
                objProfileCheck:{
                    id:'',
                    name: '',
                    department: '',
                    time:'',
                },
            }
        },
        computed: {
            getTokenUrl(){
                return typeof(this.$route.query.token) === "undefined" || this.$route.query.token === "" ?  this.$router.push("/notfound").catch(err => {}) : this.$route.query.token
            },
        },
        methods: {
            updateCurrentTime() { this.currentTime = this.moment().locale('th').format('LTS'); },
            clearDataObj(){
                this.items = []
                this.objProfileCheck.id = ''
                this.objProfileCheck.name = ''
                this.objProfileCheck.department = ''
                this.objProfileCheck.time = ''
                this.valKey = ''
            },
            otherMethod(response){
                // console.log(response.event.keyCode)
                if(response.event.keyCode >= 48 && response.event.keyCode <= 57){
                    var temp = response.event.keyCode-48
                    this.valKey += `${temp}`
                }else if(response.event.keyCode >= 96 && response.event.keyCode <= 105){
                    var temp = response.event.keyCode-96
                    this.valKey += `${temp}`
                }else if(response.event.keyCode === 8 || response.event.keyCode === 46){
                    this.valKey = this.valKey.substring(0, this.valKey.length - 1);
                }else if(response.event.keyCode == 188){
                    this.valKey = this.valKey+','
                }
            },
            async checkTimeWork(){
                this.msgError = ""
                this.loadingScan = true
                this.itemCheck = []
                try {
                    const resScan = await this.$http.get(`/checkcovid19/?staff_id=${this.valKey}&token=${this.getTokenUrl}`)
                    this.valKey = ''
                    if(resScan.status === 200){
                        this.objProfileCheck.id = resScan.data[0].staff_id
                        this.objProfileCheck.name = resScan.data[0].staff_name
                        this.objProfileCheck.department = resScan.data[0].staff_department
                        this.objProfileCheck.time = this.moment(resScan.data[0].created_at).format('LTS')
                        this.loadingScan = false
                        // clear
                        setTimeout( ()=> 
                            this.clearDataObj()
                        , 5000);
                    }else{
                        throw { resScan }
                    }
                } catch (error) {
                    this.clearDataObj()
                    this.loadingScan = false
                    this.msgError = `Problem timeattandance scan , API : /checkcovid19/?staff_id=${this.valKey}&token=${this.getTokenUrl}`
                }
            }
        },
        created() {
            this.currentTime = this.moment().locale('th').format('LTS');
            setInterval(() => this.updateCurrentTime(), 1 * 1000);
            // setInterval(() => this.refreshPage(), 1 * 3000);
        },   
    }
</script>

<style lang="scss" scoped>
    .bg-black{ background-color: #ffffff; }
    .font-01{ font-family: 'Kanit', sans-serif; font-weight: 100; }
    .height-card{  height: 300px; }
    .card-custom {
        box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
        transition: 0.3s;
        border-radius: 20px;
    }
    .bg-card{
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        background-image: url("../../assets/img/bg_time_attandance.png");
    }
    .bg-main{
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        background-image: url("../../assets/img/bg_maintime_attandance.png");
    }
    .alert-dark-custom {
        color: #1b1e21;
        background-color: #0000008f;
        border-color: #c6c8ca;
    }
    .alert-danger-custom{
        color: #1b1e21;
        background-color: #f9f9f9;
        border-color: #c6c8ca;
    }
    .danger-custom {
        color: #fd0000;
    }
    .clock-warning{
        color: #ffed1d;
    }
    .check-success{
        color: #3eff79;
    }
    .check-warning{
        color: #f54444;
    }
</style>